import { Badge } from '@/components/ui/badge';
import { ROLE_LABELS } from '@/lib/constants';
import type { Role } from '@trinco/shared';

const ROLE_COLORS: Record<Role, string> = {
  admin: 'bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-400',
  director: 'bg-purple-100 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400',
  associate: 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400',
  portco_founder: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-400',
};

interface RoleBadgeProps {
  role: Role;
}

export function RoleBadge({ role }: RoleBadgeProps) {
  return (
    <Badge variant="secondary" className={ROLE_COLORS[role]}>
      {ROLE_LABELS[role]}
    </Badge>
  );
}
